module.exports = __webpack_public_path__ + "img/kg_kg_03.9b135a0d.png";